export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/piano.82688c2.svg";